import React, { useState } from "react";
import clsx from "clsx";

import Flicking from "@egjs/react-flicking";
import { AutoPlay } from "@egjs/flicking-plugins";
import { OutBannerDTO } from "@app/bf-api";
import { RelAttributes } from "@app/constants";

import styles from "./homepage-banners.module.scss";

export interface IHomepageBannersProps {
  banners: OutBannerDTO[];
}

const HomepageBanners = ({ banners }: IHomepageBannersProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className={styles.root} style={{ "--banner-count": banners.length } as any}>
      {banners.length > 1 && (
        <div className={styles.dots}>
          {banners.map((_, i) => (
            <div key={i} className={clsx(styles.dot, activeIndex === i && styles.activeDot)} />
          ))}
        </div>
      )}
      <Flicking
        cameraClass={styles.slider}
        disableOnInit
        circular
        plugins={[
          new AutoPlay({
            duration: 5000
          })
        ]}
        onWillChange={(e) => setActiveIndex(e.index)}
      >
        {banners.map((banner, index) => (
          <a
            key={index}
            className={styles.banner}
            href={`/out/banner/${banner?.slug}/`}
            rel={RelAttributes.SPONSORED}
            target="_blank"
          >
            <img src={banner.bannerImage?.url} alt={banner.bannerImage?.alt} className={styles.image} />
          </a>
        ))}
      </Flicking>
    </div>
  );
};

export { HomepageBanners };
